import {
  Component,
  effect,
  inject,
  input,
  output,
  signal,
} from "@angular/core";
import { Icon } from "../utils/icon/icon";
import { Router, RouterLink } from "@angular/router";
import { Modal } from "../utils/modal/modal";
import { TranslocoModule } from "@jsverse/transloco";

@Component({
  selector: "app-card-favorite",
  imports: [Icon, RouterLink, Modal, TranslocoModule],
  templateUrl: "./card-favorite.html",
})
export class CardFavorite {
  objectId = input.required<string>();
  title = input.required<string>();
  subtitle = input<string>();
  link = input<string>();
  textDisclaimer = input<string>();
  isRedirectionExternal = input<boolean>(true);

  isInEditMode = input<boolean>(false);
  isSelected = output<string>();
  isModalOpen = signal<boolean>(false);

  router = inject(Router);

  constructor() {
    effect(() => {
      document.body.style.overflow = this.isModalOpen() ? "hidden" : "";
    });
  }

  goToLink(): void {
    window.open(this.link(), "_blank", "noopener,noreferrer");
    this.closeModal();
  }

  closeModal(): void {
    this.isModalOpen.set(false);
  }

  openModal(): void {
    this.isModalOpen.set(true);
  }
}
